module.exports = __webpack_public_path__ + "img/img_1.27dde299.png";